import { render, staticRenderFns } from "./notFoundRecords.vue?vue&type=template&id=7942063e&"
import script from "./notFoundRecords.vue?vue&type=script&lang=js&"
export * from "./notFoundRecords.vue?vue&type=script&lang=js&"
import style0 from "./notFoundRecords.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports